import type { TTEObject } from '@timeedit/types';

// Associations added since the object was opened, per kind, as the keys the lists mark rows by
export type ObjectManagerDirtyFields = {
  members?: string[];
  availabilityRelations?: string[];
  optionalRelations?: string[];
};

export const getUpdatedDirtyFields = (
  patch: Partial<TTEObject>,
  base: TTEObject,
  dirtyFields: ObjectManagerDirtyFields
): ObjectManagerDirtyFields => {
  const updated = { ...dirtyFields };
  // Only the kinds in the patch are recomputed; the others keep their marks from earlier edits
  if (patch.members) {
    updated.members = addedKeys(patch.members, base.members, (member) =>
      member.objectId.toString()
    );
  }
  if (patch.availabilityRelations) {
    updated.availabilityRelations = addedKeys(
      patch.availabilityRelations.flatMap((relation) => relation.objectIds),
      base.availabilityRelations.flatMap((relation) => relation.objectIds),
      String
    );
  }
  if (patch.optionalRelations) {
    updated.optionalRelations = addedKeys(
      patch.optionalRelations,
      base.optionalRelations,
      String
    );
  }
  return updated;
};

// Keys of `items` that `baseItems` lacks; undefined when none, so a kind without additions
// carries no entry. `keyOf` decides identity: two items with the same key are the same item.
const addedKeys = <T>(
  items: T[],
  baseItems: T[],
  keyOf: (item: T) => string
): string[] | undefined => {
  const baseKeys = new Set(baseItems.map(keyOf));
  const added = items.map(keyOf).filter((key) => !baseKeys.has(key));
  return added.length > 0 ? added : undefined;
};
